// extracted by mini-css-extract-plugin
module.exports = {"title":"WhatsAppTemplatePreview_title__2VZjr","info":"WhatsAppTemplatePreview_info__1n0pE"};